import CompanyCrud from './CompanyCrud.vue'
export {CompanyCrud}
export default CompanyCrud

